/**
 * Demandes des clients : leur qualification est un travail de bureau. Elles
 * vivent dans l'espace Interventions depuis le 17/10/2026 (onglet « Demandes »,
 * fiche et saisie d'un appel) ; l'ancienne adresse `/demandes` y mène toujours.
 */
import { lazy, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import type { AppRoute } from '../../app/route-types.js';
import { legacyRequestsTarget } from './request-format.js';

const RequestDetailPage = lazy(() => import('./RequestDetailPage.js').then((m) => ({ default: m.RequestDetailPage })));
const NewRequestPage = lazy(() => import('./NewRequestPage.js').then((m) => ({ default: m.NewRequestPage })));

/** `/demandes?…` (signets, avis, urgences) : la file ou la fiche, les filtres gardés. */
function RequestsRedirect(): ReactNode {
  const { search } = useLocation();
  return <Navigate to={legacyRequestsTarget(search)} replace />;
}

const QUALIFY = { anyOf: ['intervention.create_any'] } as const;

export const requestsRoutes: AppRoute[] = [
  { path: '/demandes', element: <RequestsRedirect />, gate: QUALIFY },
  { path: '/interventions/demandes', element: <Navigate to="/interventions?onglet=demandes" replace /> },
  { path: '/interventions/demandes/nouvelle', element: <NewRequestPage />, gate: QUALIFY },
  { path: '/interventions/demandes/:id', element: <RequestDetailPage />, gate: QUALIFY },
];
